#!/usr/bin/env node
/*
 * @Author: Yuki
 * @Date: 2021-04-12 10:54:42
 * @LastEditTime: 2022-11-27 13:19:12
 * @LastEditors: Yuki
 * @Description: next-server
 * @FilePath: \npm-tools\yuki-next-server-express\src\index.js
 */
const next = require('next');
const {parse} = require('url');
const dev = process.env.NODE_ENV !== 'production';
const app = next({
    dev
});
const handle = app.getRequestHandler();
const express = require('express');
const cookieParser = require('cookie-parser');
const {createProxyMiddleware: proxyMiddleware} = require('http-proxy-middleware');
const path = require('path');
const fs = require('fs');
let port = 3000;
let devProxy = null;
let https = false;
let serverAllFunc = (req, res) => {
    const parsedUrl = parse(req.url, true);
    handle(req, res, parsedUrl);
};
if(fs.existsSync(path.resolve(process.cwd(), './server/server.config.js'))) {
    const {port: newPort, devProxy: newDevProxy, handlers: newHandlers, https: newHttps} = require(path.resolve(process.cwd(), './server/server.config.js'));
    if(newPort) port = newPort;
    if(newDevProxy) devProxy = newDevProxy;
    if(newHandlers) serverAllFunc = newHandlers;
    if(newHttps) https = newHttps;
}
const options = {
    key: fs.readFileSync(path.join(__dirname, './yuki.com+5-key.pem')),
    cert: fs.readFileSync(path.join(__dirname, './yuki.com+5.pem'))
};
const serverPort = parseInt(process.env.PORT, 10) || port;
app.prepare()
    .then(() => {
        const server = express();
        const httpServer = require('http').createServer(server);
        const httpsServer =  require('https').createServer(options, server);
        if(devProxy)
            Object.keys(devProxy).forEach(context => {
                server.use(proxyMiddleware(context, devProxy[context]));
            });
        server.use(express.json());
        server.use(cookieParser());
        server.use(express.urlencoded({extended: true})); //调用中间件
        const routeNames = fs.readdirSync(path.resolve(process.cwd(), './server/routes')).map(routeName => routeName.split('.')[0]);
        routeNames.forEach(routeName => {
            const filenames = fs.readdirSync(path.resolve(process.cwd(), `./server/routes/${routeName}`)).map(filename => filename.split('.')[0]);
            filenames.forEach(filename => {
                server.use(`/${routeName}/${filename}`, require(path.resolve(process.cwd(), `./server/routes/${routeName}/${filename}`)));
            });
        });
        server.all('*', (req, res) => serverAllFunc(req, res, app, parse));
        // socket
        if(fs.existsSync(path.resolve(process.cwd(), './server/socket/index.js'))) {
            const io = require('socket.io')(https ? httpsServer : httpServer, {cors: true});
            const socket = require(path.resolve(process.cwd(), './server/socket'));
            socket(io);
        }

        (https ? httpsServer : httpServer).listen(serverPort, err => {
            if(err)
                throw err;
            else
                console.log(`> Ready on ${https ? 'https' : 'http'}://localhost:${serverPort}`);
        });
    })
    .catch(err => {
        console.log('An error occurred, unable to start the server');
        console.log(err);
    });
